import { TableControls, TableHead, TableStatusInfo } from 'components/molecules';
import styled, { css } from 'styled-components';
import { GameType, RouletteColorResult } from 'types/tables';
import { resultStyles } from 'components/molecules/RouletteResult/styles';
import fontService, { FontWeight } from 'services/FontService';

// TODO: move gradients into theme const

export const Wrapper = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background: linear-gradient(180deg, rgba(18, 16, 17, 0.24) 0%, rgba(18, 16, 17, 0.4) 86.04%),
    #121011;

  ${({ theme: { button } }) => css`
    border-bottom: 1px solid ${button.primary};
  `}
`;

export const TableHeadStyled = styled(TableHead)`
  max-width: 1280px;
  width: 100%;
  padding: 0 64px;
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 445px 675px;
  column-gap: 32px;
  max-width: 1280px;
  width: 100%;
  margin: 32px auto 0;
  padding: 0 64px;
`;

export const ControlsWrapper = styled.div``;

export const TableStatusInfoStyled = styled(TableStatusInfo)``;

export const TableControlsStyled = styled(TableControls)`
  margin-top: 24px;
`;

export const CloseNotificationWrapper = styled.div`
  margin-top: 32px;
`;

export const AlertWrapper = styled.div`
  margin-top: 12px;
`;

export const ViewWrapper = styled.div`
  min-height: 592px;
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: 12px;
  overflow: hidden;

  ${({ theme: { background } }) => css`
    border-color: ${background.secondaryDefault};
    background: ${background.primaryContrast}
      linear-gradient(180deg, rgba(52, 52, 52, 0) 45.86%, #343434 100%);
  `}
`;

export const HistoryResult = styled.div<{ gameType: GameType }>`
  position: absolute;
  top: 24px;
  left: 24px;
  display: flex;
  flex-direction: ${({ gameType }) => (gameType === GameType.ROULETTE ? 'column-reverse' : 'row')};
  z-index: 2;
`;

export const ConnectionStatusWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  z-index: 2;
`;

export const BallWrapper = styled.div`
  width: 24px;
  height: 24px;
  &:not(:first-of-type) {
    margin-left: 8px;
  }
`;

export const RouletteResultElement = styled.div<{ $color: RouletteColorResult; $isLast: boolean }>`
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $color }) => resultStyles[$color]};
  border: ${({ $isLast }) => ($isLast ? '1px solid #dfe6f4' : '1px solid #434343A3')};

  &:not(:first-child) {
    margin-bottom: 6px;
  }
`;

export const ResultNumber = styled.div`
  ${fontService.getFont({ size: 32, lineHeight: 140, weight: FontWeight.bold })};
  ${({ theme: { text } }) => css`
    color: ${text.primaryDefault};
  `};
`;

export const Block = styled.div`
  margin: 90px 0;
`;

export const BarcodeForm = styled.div`
  display: grid;
  grid-template-columns: auto 148px;
  align-items: end;
  gap: 8px;
  margin-bottom: 24px;

  input {
    padding: 9px 15px;
    border-radius: 8px;
    font-size: 22px;

    ::placeholder {
      font-size: 22px;
    }
  }
`;

export const BarcodeFormButton = styled.div`
  width: 148px;
`;

export const BlockCards = styled.span`
  color: #d4bb93;
`;
